import React from 'react';
import './assets/style.less';
import Lottie from "lottie-react";
import lottie from "./assets/lottie.json";
import { emitter, E_GET_INTER } from '../../event';

const 
    Items = [ 'Пожать руку', // 1
                'Показать паспорт', // 2
                'Показать лицензии',  // 3
                'Показать мед.карту', // 4
                'Показать навыки',  // 5
                'Попросить показать удостоверение', // 6 
                'Передать деньги' // 7
            ];

type InterInterface = {
    show:boolean;
    info:boolean;
    name:string;
    items: Array<number>
    selectItem: number;
    post: boolean;
}

const importAll = (r:any) => {
    let images:any = {};
    r.keys().map((item:any, index:number) => { return images[item.replace('./', '')] = r(item).default; });
    return images;
}
  
const images = importAll(require.context('./assets', false, /\.(png|jpe?g|svg)$/));
// (lottieRef:React.RefObject<any>, complete: () => void)
const InterLottie = ()=> {
    return <Lottie 
                   // onComplete={complete}
                   // lottieRef={lottieRef} 
                   animationData={lottie}
                   //@ts-ignore
                   loop={true}
                   autoplay={true} 
          />;
  };
  
class Interaction extends React.Component<any, InterInterface> {
    count: number;
    Items: number;
    constructor(props: any) {
        super(props);
        this.state = {
            show: false,
            info: false,
            name: 'Player Name',
            items: [1, 2, 3, 4, 5, 6, 7 ],
            selectItem: 0,
            post: false
        }
        this.Items = this.state.items.length >= 4 ? 4 : this.state.items.length;
        this.count = this.state.items.length;
    }
    unsubscribe = () => {};
    selectItemClick = ( id: number ) => {
        window.cef.set_focus( false );
        this.setState({show:false, post: true, info: true});
        window.cef.emit( "cef:interResponse", 1, id >= 0 ? this.state.items[id] : -1 );
        return;
    }
    setCurrentItem = ( value:number ) => {
        if( value > 0 ) {
            if( this.state.selectItem <  this.count-1 ) 
                this.setState({...this.state, selectItem: this.state.selectItem+1});
            return;    
        }
        else {
            if( this.state.selectItem > 0 ) 
                this.setState({...this.state, selectItem: this.state.selectItem-1});
            return;    
        }
    }


    keyup = (e: any) => {
        if( (this.state.show !== true && ( this.state.post !== true || ( this.state.post === true && e.keyCode !== 69 )) ) || 
            //  (this.state.info === false && e.keyCode === 69) || 
             (this.state.info === true && e.keyCode !== 69)  ) //|| (this.state.info === true && e.keyCode !== 73) 
             return
        switch( e.keyCode ) {
            case 40: 
                return this.setCurrentItem( 1 );
            case 38: 
                return this.setCurrentItem( -1 );
            case 13: 
                return this.state.info === true ? this.showInterSend() : this.selectItemClick( this.state.selectItem );
            case 27:
                return this.selectItemClick( -1 );
            case 69: {
                if( this.state.info === true )
                    return this.showInterSend();
                else 
                    return this.selectItemClick( -1 );
            }
            // case 18:
            //      return this.showInterSend();
        }
        return;
    }   
    onWheel = (e:any) => {
        this.setCurrentItem( e.deltaY > 0 ? 1 :-1 );
    }
    componentWillUnmount = () => {
        this.unsubscribe();
        document.removeEventListener('keydown', this.keyup);    
        document.removeEventListener('wheel', this.onWheel );
    }
    componentDidMount = () => {
        this.count = this.state.items.length;
        this.unsubscribe = emitter.subscribe(E_GET_INTER, ( data:any ) => this.showInter(data));
        document.addEventListener('keydown', this.keyup);  
        document.addEventListener('wheel', this.onWheel );
    }
    showInter = (data:string) => {
        let result:InterInterface = JSON.parse(data, function(key, value) {  return value; });
        if( result.info === false )
            window.cef.set_focus( result.show );
        this.setState({...this.state, ...result, post: false });
        if( result.items ) {
            this.Items = result.items.length >= 4 ? 4 : result.items.length;
            this.count = result.items.length;
        }
        return;
    }
    componentDidUpdate = () => {
        this.count = this.state.items.length;
    }
    showInterSend = () => {
        this.setState( {show: false} );
        window.cef.emit( "cef:interResponse", 0, -1 );
//        window.cef.emit( "interactivecef", 0, -1 );
        return;
    }

    render() { 
        if( this.state.show === false ) 
            return null;
        if( this.state.info === true ) 
            return <>
            <div className={'interact_info'} >
                 
                <div><div>{InterLottie()}</div><h1>для взаимодействия<br/>Нажмите E</h1></div>
            </div>
            </>
        return <>
            <div className="interact_blur" />
            <div className={'interact_name'}>
                <h1>{this.state.name}</h1>
            </div>
            <div className={'interact_main'}>
                <div className={'interact_scroll'}>
                {this.state.items.map((data, id) => {
                    if( data < 0 || id <  this.state.selectItem - this.Items || id > this.state.selectItem + this.Items ) return null;
//                    let left_offset = ( this.count > this.Items ? this.Items:this.count)*ItemLeft - ItemLeft* (id > this.state.selectItem ? ( id-this.state.selectItem) : ( this.state.selectItem-id) ),
                        let opacity = 0.99-( id-this.state.selectItem)/(id > this.state.selectItem ? 5:-5);
                        // marginLeft: `${left_offset}vw`
                        return (
                                <div key={id} className={'interact_item'} style={{ marginLeft: id === this.state.selectItem ? '2vw': '0vw', opacity: opacity }} onClick={() => { this.selectItemClick( id ) }}>
                                        <div><img src={ images[`${data}.svg`]} alt=''></img></div>
                                        <p>{Items[data-1] }</p>
                                </div>
                          )
                })}
                </div>
            </div>
        </>
    }
}

export default Interaction;